import { gql } from '@apollo/client';

export const PROPERTY_ARTICLES_QUERY = gql`
  query ProjectnetPosts($projectNetPropertyId: Int) {
    projectArticles: posts(
      request: { perPage: 20, projectNetPropertyId: $projectNetPropertyId }
    ) {
      items {
        id
        postCategory
        link
        videoType
        propertyType
        projectNetPropertyId
        title
        tags {
          id
          name
          link
        }
        featuredImage {
          url
          title
          width
          height
        }
        author {
          id
          nickname
          name
          link
          profileImage {
            url
            title
            width
            height
          }
        }
        totalComments
        embedVideo
      }
    }
  }
`;
